import {
  CalendarDays,
  ClipboardCheck,
  ClipboardList,
  Presentation,
  UserCheck,
} from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import {
  SWOOGO_ATTENDANCES_ACLS,
  SWOOGO_EVENTS_ACLS,
  SWOOGO_REGISTRANTS_ACLS,
  SWOOGO_SESSIONS_ACLS,
} from "constants/NavigationAcls";
import useAuthorized from "hooks/useAuthorized";
import useSwoogoConnected from "routes/swoogo/useSwoogoConnected";

export const SWOOGO_SECTIONS = [
  {
    key: "events",
    label: "Events",
    icon: CalendarDays,
    acl: SWOOGO_EVENTS_ACLS[0],
  },
  {
    key: "registrants",
    label: "Registrants",
    icon: UserCheck,
    acl: SWOOGO_REGISTRANTS_ACLS[0],
  },
  {
    key: "sessions",
    label: "Sessions",
    icon: Presentation,
    acl: SWOOGO_SESSIONS_ACLS[0],
  },
  {
    key: "attendances",
    label: "Attendances",
    icon: ClipboardCheck,
    acl: SWOOGO_ATTENDANCES_ACLS[0],
  },
  {
    key: "activity",
    label: "Activity Logs",
    icon: ClipboardList,
    acl: ACL_RELATIONSHIPS.auditLog.read,
    requiresConnection: true,
  },
];

// The sections the user can open, in display order. Shared by the sidebar and
// the account page so the two cannot drift.
export const useReadableSwoogoSections = () => {
  const { connectionId } = useSwoogoConnected();
  const { grantedInfo } = useAuthorized(
    SWOOGO_SECTIONS.map(section => section.acl),
    { shouldReturnGrantedInfo: true }
  );

  return SWOOGO_SECTIONS.filter(
    (section, index) =>
      grantedInfo[index]?.granted &&
      (!section.requiresConnection || connectionId)
  );
};
